/* eslint-disable  */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
// React Components
/* eslint-disable */
import React, { useEffect, useState, Suspense, lazy } from "react";
/* eslint-disable */
import "../layout-one/sass/app.scss";
import "../layout-two/sass-react/app.scss";
/* eslint-disable */
import ReactGA from "react-ga";
import { configure } from "mobx";
import DineInMain from "./DineInMain";
import DeliveryMain from "./DeliveryMain";
import EnabillLoadingPage from "../sharedComponent/enabillLoadingPage/enabillLoadingPage";
import { use } from "react";
import { useSelector } from "react-redux";

// const EnabillLoadingPage = lazy(() => import(
//   '../sharedComponent/enabillLoadingPage/enabillLoadingPage'))

configure({
  isolateGlobalState: true,
});
// const TRACKING_ID = "UA-243425614-1"; // OUR_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);

function Main({ t, i18n }) {
  const appState = useSelector((appState) => appState);
  const [appMode, setAppMode] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    let initial_mount = true;
    if (initial_mount) {
      let delivery = true;
  
      if (delivery) {
        setAppMode(2);
        setIsLoading(false);
      } else {
        setAppMode(1);
        setIsLoading(false);
      }
  
      let trakingDomain = window.location.host === 'tikkawkabab.com' || window.location.host === 'lazurd.enabill.com';
      let gmt = process.env.REACT_APP_GTM_ID ?? null;
      let pixelID = process.env.REACT_APP_PIXEL_ID ?? null;
  
      if (trakingDomain) {
        if(gmt){
        // Load Google Analytics
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gmt}`;
        document.head.appendChild(gtagScript);
  
        gtagScript.onload = () => {
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', gmt);
        };
      }
      if(pixelID){
        // Load Facebook Pixel
        const fbPixelScript = document.createElement('script');
        fbPixelScript.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelID}');
          fbq('track', 'PageView');
        `;
        fbPixelScript.setAttribute('type', 'text/javascript');
        document.head.appendChild(fbPixelScript);
  
        // Optional: add noscript fallback
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${pixelID}&ev=PageView&noscript=1"/>
        `;
        document.body.appendChild(noscript);
      }
    }
    }
    return () => {
      initial_mount = false;
    };
  }, []);
  
  return appMode == 1 ? <div> <DineInMain />  </div>: appMode == 2  ? <div> <DeliveryMain />  </div>: <div> <EnabillLoadingPage /> </div>;

}

export default Main;
